module.exports = __webpack_public_path__ + "img/cragg.b176104e.jpg";